import React from 'react';
import classnames from 'classnames';
import Icon from '../Icon';

import './style.scss';

const PREFIX = 'music';

export type CoverSize = 'small' | 'medium' | 'large';

export interface CoverProps {
  /** 封面图片 URL */
  src?: string;
  /** 尺寸：small=48px, medium=120px, large=150px */
  size?: CoverSize;
  /** 自定义类名 */
  className?: string;
  /** 替代文字 */
  alt?: string;
  /** 点击回调 */
  onClick?: () => void;
}

const SIZE_MAP: Record<CoverSize, number> = {
  small: 48,
  medium: 120,
  large: 150,
};

export default function Cover({ src, size = 'large', className, alt = 'cover', onClick }: CoverProps) {
  const coverSize = SIZE_MAP[size];
  
  return (
    <div
      className={classnames(
        `${PREFIX}-cover`,
        `${PREFIX}-cover--${size}`,
        { [`${PREFIX}-cover--clickable`]: !!onClick },
        className
      )}
      style={{ width: coverSize, height: coverSize }}
      onClick={onClick}
    >
      {src ? (
        <img src={src} alt={alt} className={`${PREFIX}-cover__image`} />
      ) : (
        <div className={`${PREFIX}-cover__placeholder`}>
          <Icon style="MusicBig" size={size === 'small' ? 'small' : 'medium'} />
        </div>
      )}
    </div>
  );
}
